import { IFormField } from '../../../shared/interfaces/forms/IForms';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { formDataHeaders, requests } from '../../../utils/api/api.service';
import { FORMS_URL, USER_URL } from '../../../utils/api/endpoints';
import { ICalendarPagination } from '../calendar';

export const AdminEmployeeService = {
  getAll: (params: IPagination) => requests.get(USER_URL, params),
  create: (payload: FormData) =>
    requests.post(USER_URL, payload, formDataHeaders),
  update: (payload: FormData, id: number): Promise<IUser> =>
    requests.put(`${USER_URL}/${id}`, payload, formDataHeaders),
  delete: (id: number) => requests.delete(`${USER_URL}/${id}`),
  getSingle: (id: number) => requests.get(`${USER_URL}/${id}`),
  getPreview: (id: number) => requests.get(`${USER_URL}/preview/${id}`),
  getCalendarData: (pagination: ICalendarPagination) =>
    requests.get(`${USER_URL}/calendar-data`, pagination),
  getFormFields: (
    userId: number,
  ): Promise<{
    1: IFormField[];
    2: IFormField[];
    3: IFormField[];
    4: IFormField[];
    5: IFormField[];
  }> => requests.get(`${FORMS_URL}/user/${userId}`),
};
